// The parking page menu scrolls to its sections.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.section--parking_menu a').forEach((link) => link.addEventListener('click', (e) => {
        e.preventDefault();

        const anchor = e.target.getAttribute('href');
        const section = document.querySelector(`[data-location='${anchor}']`);
        window.scrollTo({ top: section.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
    }));
});
